// 判断一个模块导出是否“像 class 一样需要 new”。
// 这里不能只用 `typeof xxx === 'function'`：
// 1. 普通函数工厂也是 function，但不应该被 new
// 2. MobX Mod 常见是 class export，需要实例化后才能当 Store 用
function isClassLike(modExport) {
  if (typeof modExport !== 'function') {
    return false;
  }

  // 原生 class / Babel 编译后的 class，大多数情况下 toString 都能识别出 class 关键字。
  const source = Function.prototype.toString.call(modExport);
  if (/^class\s/.test(source)) {
    return true;
  }

  // 没有 prototype 的函数一般不是 class，也不适合当构造器直接 new。
  if (!modExport.prototype) {
    return false;
  }

  // 再兜底看 prototype 上是否存在除 constructor 之外的方法。
  // 如果有，通常说明它更像一个 class 实例方法集合，而不是简单函数。
  return Object.getOwnPropertyNames(modExport.prototype).some((name) => name !== 'constructor');
}

// 统一把动态 import 回来的模块导出转换成“运行时可直接使用的 Store”。
//
// 兼容几种场景：
// 1. `export default class XxxMod {}`      -> 需要 new 后返回实例
// 2. `export default function xxx() {}`    -> 直接返回函数本身
// 3. `export default { ... }`              -> 直接返回对象
// 4. 空导出 / 加载异常兜底                 -> 原样返回，交给上层处理
export default function resolveModExport(modExport) {
  if (!modExport) {
    return modExport;
  }

  // class 导出返回实例；非 class 导出保持原值，避免误 new 普通函数。
  return isClassLike(modExport) ? new modExport() : modExport;
}



// WEBPACK FOOTER //
// ./src/utils/resolveModExport.js